module.exports = __webpack_public_path__ + "static/media/speaker.b1e57917.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/speaker.svg
// module id = 2243
// module chunks = 0